import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Modal,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import en from "../../locales/en";
import ar from "../../locales/ar";
import { useRouter } from "next/router";
import { colors } from "@/utils/const";

export default function Terms_and_condation_form({
  agreeTerms,
  setAgreeTerms,
}) {
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialogOpen = () => setOpenDialog(true);
  const handleDialogClose = () => setOpenDialog(false);
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : ar;
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 450,
    minWidth: 300,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
    border: "none",
    outline: "none",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",

    borderRadius: "20px",
  };
  return (
    <>
      <FormControlLabel
        control={
          <Checkbox
            checked={agreeTerms}
            onChange={() => setAgreeTerms(!agreeTerms)}
            sx={{
              color: "#F18222",
              borderRadius: "4px",
              mb: 2,
              mr: t === "ar" ? 0 : -2.2,
              "&.Mui-checked": {
                color: "#F18222",
              },
            }}
          />
        }
        label={
          <Box>
            <Typography
              sx={{
                color: "#3C4350",
                fontSize: "12px",
                fontWeight: "400 important",
                lineHeight: "16px",
                wordWrap: "break-word",
                ml: 1.5,
              }}
            >
              {t.form_labels.terms.substring(0, 150) + ".... "}
              <Button
                onClick={handleDialogOpen}
                sx={{
                  color: "#2D317F",
                  p: 0,
                  // mt: "-1.4px",
                  "&.MuiButton-root": {
                    fontWeight: "700 !important",
                    fontSize: "12px !important",
                  },
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                {` ${t.form_labels.showmore}`}
              </Button>
            </Typography>
          </Box>
        }
      />
    
      <Modal
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <CloseIcon
            sx={{
              fontSize: "20px",
              position: "absolute",
              top: "18px",
              left: locale == "en" ? "18px" : "",
              right: locale == "ar" ? "18px" : "",
              cursor: "pointer",
            }}
            onClick={handleDialogClose}
          />
          <Typography
            sx={{
              textAlign: "center",
              mt: 2,
              fontSize: "20px",
              fontWeight: "600",
              color: colors.blue,
            }}
          >
            {" "}
            {t.footer.section_b.Terms_and_Conditions}
          </Typography>
          <Typography
            id="modal-modal-description"
            // className={locale === "en" ? enFont.className : arFont.className}
            sx={{ textAlign: "center", mt: 2, color: "#686B7A" }}
          >
            {t.form_labels.terms}
          </Typography>
          <Box
            component="img"
            alt="line"
            src="/line.png"
            sx={{
              width: "130%",
              height: "7px",
              position: "relative",
              top: "33px",
            }}
          />
        </Box>
      </Modal>
    </>
  );
}
